import { useCallback, useState } from 'react';

import { useNotificationPref } from 'hooks/useNotificationPref';
import { BROWSER_NOTIFICATIONS_STORAGE_KEY } from 'hooks/useNotificationPref/constants';

import { getNotificationPermission } from './utils';

const useTeamChatBrowserNotifications = () => {
  const [permission, setPermission] = useState(getNotificationPermission);
  const [isEnabled, setIsEnabled] = useNotificationPref(BROWSER_NOTIFICATIONS_STORAGE_KEY);

  const onRequestPermission = useCallback(async () => {
    if (typeof window === 'undefined' || !('Notification' in window)) {
      return 'unsupported';
    }

    const result = await window.Notification.requestPermission();

    setPermission(result);

    if (result === 'granted') {
      setIsEnabled(true);
    }

    return result;
  }, [setIsEnabled]);

  const onToggleEnabled = useCallback(async () => {
    if (!isEnabled && permission !== 'granted') {
      const result = await onRequestPermission();

      if (result !== 'granted') {
        return;
      }
    }

    setIsEnabled(!isEnabled);
  }, [isEnabled, permission, onRequestPermission, setIsEnabled]);

  return {
    isSupported: permission !== 'unsupported',
    isEnabled: isEnabled && permission === 'granted',
    permission,
    onToggleEnabled,
    onRequestPermission,
  };
};

export default useTeamChatBrowserNotifications;
